(function () {
    'use strict';

    angular
        .module('app')
        .controller('LeadsListController', LeadsListController);

    LeadsListController.$inject = ['API', 'alert', 'debug', 'i18n', 'ListViewSearchExtension', '$stateParams'];

    function LeadsListController(API, alert, debug, i18n, ListViewSearchExtension, $stateParams) {
        var vm = this;
        vm.searchTerm = '';
        vm.page = 1;
        vm.perPage = 20;
        vm.search = search;
        vm.clearSearch = clearSearch;

        ListViewSearchExtension.extendScope(vm);
        vm.listObject.filter = {
            campaignType: '',
            sort: 'latestFirst',
        };

        vm.listMeta = {};
        vm.loadingState = {
            leadIsLoading: false
        };
        vm.openRemoveModal = openRemoveModal;
        vm.loadPage = loadPage;
        vm.keyUp = keyUp;
        vm.loadResources = loadResources;

        activate();

        function activate() {
            if ($stateParams.searchObject) {
                vm.loadParams(JSON.parse($stateParams.searchObject));
            } else {
                loadResources();
            }
        }

        function openRemoveModal(lead) {
            var promise = alert.confirm('remove-item');

            promise.then(function() {
                var removePromise = API.Lead.delete({ id: lead.id }).$promise;

                removePromise.then(function() {
                    var index = vm.leads.findIndex(function(item) {
                        return item.id === lead.id;
                    });
                    vm.leads.splice(index, 1);
                    window.toast({ type: 'success', autoRemoveTime: 5000, message: i18n.get('LEAD_REMOVED') });
                }, function() {});
            }, function() {});
        }

        function clearSearch() {
            vm.searchTerm = '';
            vm.page = 1;
            loadResources();
        }

        function search() {
            vm.page = 1;
            loadResources();
        }

        function loadPage(newPageNumber) {
            vm.page = newPageNumber;
            loadResources();
        }

        function loadResources(skipCharacterLimit) {
            var promise = null;

            var searchObject = {
                'page': vm.listObject.page,
                'per-page': vm.listObject.perPage,
                'sort': '',
                expand: ''
            };

            if (vm.listObject.filter.sort) {
                switch (vm.listObject.filter.sort) {
                    case 'latestFirst':
                        searchObject.sort = '-created';
                        break;
                    case 'oldestFirst':
                        searchObject.sort = 'created';
                        break;
                    case 'alphabetAscending':
                        searchObject.sort = '-email';
                        break;
                    case 'alphabetDescending':
                        searchObject.sort = 'email';
                        break;

                    default:
                        break;
                }
            }

            if (vm.listObject.filter.campaignType) {
                searchObject.category = vm.listObject.filter.campaignType;
            }

            if (vm.listObject.searchTerm && (vm.listObject.searchTerm.length > 2 || skipCharacterLimit)) {
                searchObject.q = vm.listObject.searchTerm;
                promise = API.Lead.search(searchObject).$promise;
            } else if (vm.listObject.searchTerm.length === 0) {
                promise = API.Lead.search(searchObject).$promise;
            }

            if (promise) {
                vm.loadingState.leadIsLoading = true;
                promise.then(function (response) {
                    vm.leads = response.items;
                    vm.listMeta = response._meta;
                    vm.loadingState.leadIsLoading = false;
                }, function (response) {
                    debug.log(response);
                });
            }
        }

        function keyUp(event) {
            if (event.keyCode === 13) {
                loadResources(true);
            }
        }
    }
})();